import HeroSection from '@/components/HeroSection';
import ComparisonSection from '@/components/ComparisonSection';
import MidPageCta from '@/components/MidPageCta';
import HowItWorksSection from '@/components/HowItWorksSection';
import ProofSection from '@/components/ProofSection';
import FinalCtaSection from '@/components/FinalCtaSection';

export default function LandingPage() {
  return (
    <>
      <HeroSection />
      <ComparisonSection />
      <MidPageCta />
      <HowItWorksSection />
      <ProofSection />
      <FinalCtaSection />
    </>
  );
}
